import { makeStyles } from '@material-ui/core';
import React from 'react'
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from 'react-redux';
import { pageSize } from './../../Redux/invoiceDetails/actions';
import { select, selectAll, deSelect, deSelectAll } from './../../Redux/invoiceDetails/actions';
import "../common/customCheckBox.css"
import dateFormat from 'dateformat';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Loader from "react-loader-spinner";
import "@fontsource/ubuntu"
import "@fontsource/roboto"
const useStyles = makeStyles({
    main: {
        overflowY: "scroll",
        height: "25.5rem",
        color: "white",
        "&::-webkit-scrollbar": {
            width: "7px",

        },
        "&::-webkit-scrollbar-track": {
            background: "#283A46"
        },
        "&::-webkit-scrollbar-thumb": {
            background: "#7e807f",
            borderRadius: "2rem",

        },
        "&::-webkit-scrollbar-thumb:hover": {
            background: "#97A1A9",
        }
    },
    header: {
        color: "#97A1A9",
        borderBottom: "1px solid #283A46",
        fontSize: "0.85rem"
    },
    tableData: {
        color: "white",
        border: "none",
        overflow: "hidden",
        whiteSpace: "nowrap",
        fontSize: "0.85rem",
        fontFamily: "Roboto"
    },
    cellCheckbox: {
        border: "none",
        width: "1%",

    },
    checkBox: {
    },
    loader: {
        color: "#97A1A9",
        fontSize: "0.8rem",
        textAlign: "center",
        marginTop: "0.5rem",
        fontFamily: "Ubuntu",
        padding: "5rem"
    },
    custName: {
        width: "11%",
        textAlign: "left"
    },
    custNum: {
        width: "8%",
        textAlign: "left"
    },
    invNo: {
        width: "8%",
        textAlign: "left"

    },
    invAmo: {
        width: "10%",
        textAlign: "right"
    },
    dueDate: {
        width: "13%",
        textAlign: "right"

    },
    predPayDate: {
        width: "14%",
        textAlign: "right"
    },
    predAgeBucket: {
        width: "14%",
        textAlign: "left"

    },
    notes: {
        width: "20%",
        textAlign: "left"
    },
    spanClass: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        width: "14rem",
        display: 'block',
        cursor: "default",
        paddingLeft: "0.7rem",
        textOverflow: "ellipsis"
    }

})
const GridData = () => {
    const data = useSelector(state => state.Data)
    const dispatch = useDispatch();
    const fetchData = () => {

        document.getElementById("MainCheckBox").checked = false;
        setTimeout(() => {
            dispatch(pageSize());
        }, 1000);
    }
    const classes = useStyles()
    const checkCount = useSelector(state => state.CheckBoxCount);
    const selectFunc = (e) => {
        if (e.target.checked) {
            dispatch(select())
            checkCount + 1 === Object.keys(data).length ? document.getElementById("MainCheckBox").checked = true : document.getElementById("MainCheckBox").checked = false
        }
        else {
            dispatch(deSelect())
            document.getElementById("MainCheckBox").checked = false
        }
    }
    const selectAllFunc = (e) => {
        var checkboxes = document.getElementsByClassName(classes.checkBox)
        e.target.checked ? dispatch(selectAll(Object.keys(data).length)) : dispatch(deSelectAll());
        e.target.checked ?
            Object.keys(checkboxes).map((i) => {
                return checkboxes[i].checked = true;
            }) : Object.keys(checkboxes).map((i) => {
                return checkboxes[i].checked = false;
            })
    }
    return (

        <>
            <Table>
                <TableBody>
                    <TableRow>
                        <TableCell className={classes.header}><label className="container"><input type="checkbox" id="MainCheckBox" onChange={(e) => selectAllFunc(e)} /><span className="checkmark"></span></label></TableCell>
                        <TableCell align="left" className={`${classes.header} ${classes.custName}`}>Customer Name</TableCell>
                        <TableCell align="left" className={`${classes.header} ${classes.custNum}`}>Customer #</TableCell>
                        <TableCell align="left" className={`${classes.header} ${classes.invNo}`}>Invoice #</TableCell>
                        <TableCell align="right" className={`${classes.header} ${classes.invAmo}`}>Invoice Amount</TableCell>
                        <TableCell align="right" className={`${classes.header} ${classes.dueDate}`}>Due Date</TableCell>
                        <TableCell align="right" className={`${classes.header} ${classes.predPayDate}`}>Predicted Payment Date</TableCell>
                        <TableCell align="left" className={`${classes.header} ${classes.predAgeBucket}`}>Predicted Aging Bucket</TableCell>
                        <TableCell align="left" className={`${classes.header} ${classes.notes}`}>Notes</TableCell>
                    </TableRow>
                </TableBody>
            </Table>

            <div className={classes.main} id="scrollableDiv">
                <InfiniteScroll

                    dataLength={Object.keys(data).length}
                    next={fetchData}
                    hasMore={Object.keys(data).length}
                    loader={
                        <div className={classes.loader}>
                            <Loader type="Oval" color="#00BFFF" height={30} width={30} />
                            <p>Loading</p>
                        </div>
                    }
                    scrollableTarget="scrollableDiv"
                >
                    <TableContainer>
                        <Table size="small">

                            <TableBody>

                                {Object.keys(data).map((item, i) => {
                                    return (

                                        <TableRow key={i} className={classes.row} style={item % 2 ? { background: "#283A46" } : { background: "transparent" }} >
                                            <TableCell className={classes.cellCheckbox}><label className="container"><input type="checkbox" onChange={(e) => selectFunc(e)} className={classes.checkBox} /><span className="checkmark"></span></label></TableCell>
                                            <TableCell align="left" className={`${classes.tableData} ${classes.custName}`}>{data[item].customerName}</TableCell>
                                            <TableCell align="left" className={`${classes.tableData} ${classes.custNum}`}>{data[item].customerNumber}</TableCell>
                                            <TableCell align="left" className={`${classes.tableData} ${classes.invNo}`}>{data[item].invoiceNumber}</TableCell>
                                            <TableCell align="right" className={`${classes.tableData} ${classes.invAmo}`}>{data[item].invoiceAmount}</TableCell>
                                            <TableCell align="right" className={`${classes.tableData} ${classes.dueDate}`} style={new Date("14-Apr-2020") > new Date(dateFormat(data[item].dueDate, "dd-mmm-yyyy")) ? { color: "#FF5B5B" } : { color: "white" }}>{dateFormat(data[item].dueDate, "dd-mmm-yyyy")}</TableCell>
                                            <TableCell align="right" className={`${classes.tableData} ${classes.predPayDate}`}>--</TableCell>
                                            <TableCell align="left" className={`${classes.tableData} ${classes.predAgeBucket}`}>--</TableCell>
                                            <TableCell align="left" className={`${classes.tableData} ${classes.notes}`}> <span title={data[item].notes} className={classes.spanClass} >{data[item].notes}</span></TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </InfiniteScroll>
            </div>
        </>
    )
}

export default GridData



